<template>
  <a-card :bordered='false'>
      <div class="s_flex_center p-b-40">
        <p>二维码编号：</p>
        <a-input class='width40 m-r-15' v-model:value="code" placeholder="请输入二维码" @pressEnter='onSubmit'/>
        <a-button type="primary" v-has:antiAuditQuery='onSubmit'>查询</a-button>
      </div>
      <p class="text-ac p-b-20" v-if='errorMsg'>{{errorMsg}}</p>
      <a-tabs v-model:activeKey="activeKey" v-if='showData'>
        <a-tab-pane :key="1" tab="基本信息">
          <a-descriptions bordered :column='2' class="m-t-20">
            <a-descriptions-item label="二维码编号" >{{codedata.code_sn || '-'}}</a-descriptions-item>
            <a-descriptions-item label="被替换二维码编号">{{codedata.replace_code_sn || '-'}}</a-descriptions-item>
            <a-descriptions-item label="防伪码号">{{codedata.security_code || '-'}}</a-descriptions-item>
            <a-descriptions-item label="码批次">{{codedata.batch_sn || '-'}}</a-descriptions-item>
            <a-descriptions-item label="码状态" :span='2'>{{codedata.status_text || '-'}}</a-descriptions-item>
            <a-descriptions-item label="生产批次" :span='2'>{{codedata.product_batch_name || '-'}}</a-descriptions-item>
            <a-descriptions-item label="商品名称" :span='2'>{{codedata.product_name || '-'}}</a-descriptions-item>
            <a-descriptions-item label="二维码类型" :span='2'>{{codedata.code_type_text || '-'}}</a-descriptions-item>
            <a-descriptions-item label="关联垛标" :span='1' ><a href="javascript:;" v-has:virtualDetail='()=>virtualShow(codedata)' v-if="codedata.virtual_sn">{{codedata.virtual_sn}}</a><span v-else>-</span> </a-descriptions-item>
            <a-descriptions-item label="关联状态" :span='1'  >{{codedata.virtual_is_bind==1?'关联中':codedata.virtual_is_bind==2?'解除关联':codedata.virtual_is_bind==3?'单独出入退':'未关联'}}</a-descriptions-item>
            <a-descriptions-item label="关联数量" :span='1'  >{{codedata.virtual_bind_num}}</a-descriptions-item>
            <a-descriptions-item label="备注" :span='2'>{{codedata.remark || '-'}}</a-descriptions-item>
            <a-descriptions-item :span='2' style="padding: 0;">
              <template v-slot:label>
                <p class="fz-14 s_ptb16lr24">包含编号</p>
              </template>
              <div class="width100 text-ac">
                <div class="s_flex_bian_c">
                  <p class="s_ptb16lr24 list_bb width34" style='background-color: #fafafa' >大标（{{codedata.big_code_num}}）</p>
                  <p class="s_ptb16lr24 list_bb width34" style='background-color: #fafafa' >中标（{{codedata.middle_code_num}}）</p>
                  <p class="s_ptb16lr24 list_bb width34" style='background-color: #fafafa' >小标（{{codedata.small_code_num}}）</p>
                </div>
                <div class="s_flex_ali " v-for='(item1,k1) in codedata.code_tree_info' :key='k1' >
                  <div class="width34" :class="code==item1.big_code?'red':''"><!--大标-->
                    {{item1.big_code}}
                    <span v-if='code_replace.findIndex(v=> v.replace_code_sn == item1.big_code) != -1'>（{{code_replace[code_replace.findIndex(v=> v.replace_code_sn == item1.big_code)].damage_code_sn}}）</span>
                  </div>
                  <div class="width66 list_bl ms_box s_over_h">
                    <template v-for='(item2,k2) in item1.middle_code_data' :key='k2'>
                      <div class="s_flex_ali width100 list_bb ms_box_item" v-if='(!lookMore?k2==0:true)'>
                        <p class="width50"  :class="code==item2.middle_code?'red':''"><!--中标-->
                          {{item2.middle_code || '-'}}
                          <span v-if='code_replace.findIndex(v=> v.replace_code_sn == item2.middle_code) != -1'>（{{code_replace[code_replace.findIndex(v=> v.replace_code_sn == item2.middle_code)].damage_code_sn}}）</span>
                        </p>
                        <div class="width50 list_bl tree_box" ><!--小标-->
                          <template v-for='(item3,k3) in item2.small_code_data' :key='k3'>
                            <p class="height-50 s_flex_center list_bb" :class="code==item3?'red':''" v-if='(!item2.lookMore?k3<15:true)'>
                              {{item3}}
                              <span v-if='code_replace.findIndex(v=> v.replace_code_sn == item3) != -1'>（{{code_replace[code_replace.findIndex(v=> v.replace_code_sn == item3)].damage_code_sn}}）</span>
                              <img src="@/assets/images/sell.png" alt=""  v-if="code_sells.indexOf(item3)!=-1" >
                              <img src="@/assets/images/break.png" alt="" v-if="codedata.un_boxing_small_code.indexOf(item3)!=-1&&code_sells.indexOf(item3)==-1"  class="m-l-5">
                            </p>
                          </template>
                          <p class="height-50 width100 s_flex_center s_shou" @click='item2.lookMore=!item2.lookMore' v-if='item2.small_code_data.length>15'>
                            {{!item2.lookMore?'查看更多':'收起'}}<up-outlined v-if='!item2.lookMore' /><down-outlined v-else />
                          </p>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="height-50 width100 s_flex_center s_shou list_bt" @click='lookMore=!lookMore' v-if='codedata.middle_code_num>1'>
                  {{!lookMore?'查看更多':'收起'}}<up-outlined v-if='!lookMore' /><down-outlined v-else />
                </div>
              </div>
            </a-descriptions-item>
          </a-descriptions>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="位置跟踪">
          <a-timeline class="m-t-20">
            <a-timeline-item v-for="(item,index) in codeline" :key='index'>
              <p class="s_lin_h30"><span class="fz-18 s_font_b">{{item.status_text}}</span><span class="s_c999 p-l-10">{{item.add_time}}</span></p>
              <p class="s_lin_h30" v-for="(items,indexs) in item.content" :key='indexs'>{{items}}</p>
            </a-timeline-item>
          </a-timeline>
        </a-tab-pane>
      </a-tabs>
  </a-card>
    <!-- 垛标信息 -->
    <a-modal :keyboard="false" title="垛标信息" centered v-model:visible="virtualPoup"  :width="1000" destroyOnClose>
        <stackMark  :codedata="virtualData"  />
    </a-modal>
</template>
<script>
import { ref, reactive, toRefs, onMounted, onUnmounted, inject } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import { useUsbRead } from "@/hooks/useUsbRead";
import { codeSearch } from '@/api/antiFleeing';
  import {DownOutlined,UpOutlined} from "@ant-design/icons-vue";
  import stackMark from './components/stackMark'
export default {
  components:{stackMark,DownOutlined, UpOutlined},
  setup() {
    const smallHeight = ref(null);
    const state = reactive({
      code:'',
      errorMsg:'', //二维码错误提示语
      codeline:[], //二维码时间轴
      codedata:{}, //二维码信息
      showData:false, //是否显示二维码查询结果
      code_sells:[],//已售小标的数组
      activeKey:1,
      code_replace:[],
      lookMore:false
    });
    const onSubmit = async () => {
      if (!state.code) {
        return message.error("请输入二维码!");
      }else{
        state.errorMsg = ''
        const hide = message.loading("正在加载中...", 0);
        let res = await codeSearch({code:state.code}).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          res.data.code_base_info.code_tree_info.forEach(v => {
            v.middle_code_data.forEach(k => {
              k.lookMore = false
            });
          });
          state.codeline = res.data.code_assembly_line;
          state.codedata = res.data.code_base_info;
          state.code_replace = res.data.code_replace;
          state.code_sells=res.data.code_sells
          state.showData = true;
          state.lookMore = false;
        } else {
          message.error(res.msg);
          state.errorMsg = res.msg
          state.showData = false
        }
        setTimeout(hide);
      }
    }
    const route=inject('$route')
    // 监听USB读取，提升到 setup 顶层作用域，确保 onUnmounted 能访问
    const { openUSBbRead, closeUSBbRead } = useUsbRead();
    
    onMounted(()=>{
      if(route.query.code){
        state.code=route.query.code
        onSubmit()
      }
      // 监听USB读卡器
      openUSBbRead((data) => {
        if (data && data != state.code) {
          state.code = data;
        }
      });
    })
    onUnmounted(() => {
      closeUSBbRead();
    });
    // 垛标详情
    const virtualHandle=function(){
      const virtualPoup=ref(false)
      const virtualData=ref({})
      const virtualShow=(data)=>{
          virtualData.value=data
          virtualPoup.value=true
      }
      return{
          virtualPoup,
          virtualShow,
          virtualData
      }
    }


    return {
      ...toRefs(state),
        onSubmit,
        smallHeight,
        ...virtualHandle()
    };
  },
};
</script>
<style lang="less" >
  .s_ptb16lr24{
    padding: 14px 24px;
  }
  .list_bl{
    border-left: 1px solid #f0f0f0
  }
  .list_bb{
    border-bottom: 1px solid #f0f0f0
  }
  .list_bt{
    border-top: 1px solid #f0f0f0
  }
  .red{
    color: #f04635;
  }
  .tree_box p:last-child  {
    border-bottom: 0;
  }
  .ms_box .ms_box_item:last-child{
    border-bottom: 0;
  }
</style>